import React, { useEffect, useState, Component } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, Mail, Send, CheckCircle, User, MessageSquare } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ContactSupport() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Contact Support | IntelliEats';
  }, []);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const subject = encodeURIComponent(`IntelliEats Support: Message from ${name}`);
    const body = encodeURIComponent(`Name: ${name}\nEmail: ${email}\n\nMessage:\n${message}`);
    window.location.href = `mailto:intellieats@gmail.com?subject=${subject}&body=${body}`;
    setSubmitted(true);
  };
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="pt-32 pb-24 bg-white min-h-screen" data-id="element-2440" data-mp="1327dwto3o8ni">
      
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2441" data-mp="3ithkitxbfalj">
        <header className="mb-12" data-id="element-2442" data-mp="3dv68qdngmq0o">
          <Link to="/" className="inline-flex items-center text-sm font-medium text-brand-600 hover:text-brand-700 mb-8 transition-colors" data-id="element-2443" data-mp="3dvxuyxv63bea">
            
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-2444" data-mp="3nlr3fq00jaeb" />
            Back to Home
          </Link>
          <div className="flex items-center gap-4 mb-6" data-id="element-2445" data-mp="2zvwu3iewk3yt">
            <div className="bg-blue-100 text-blue-600 p-3 rounded-2xl" data-id="element-2446" data-mp="2zyizpci8g9ee">
              <Mail className="w-8 h-8" data-id="element-2447" data-mp="2uyn4a1nlpqag" />
            </div>
            <h1 className="text-4xl sm:text-5xl font-black text-slate-900 tracking-tight" data-id="element-2448" data-mp="39ucnjs1ejpbh">
              Contact Support
            </h1>
          </div>
          <p className="text-lg text-slate-600" data-id="element-2449" data-mp="34u81znln04ee">
            Have a question, feedback, or need help? We'd love to hear from you.
            Fill out the form below and we'll get back to you as soon as
            possible.
          </p>
        </header>

        {submitted ? <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} className="text-center py-16" data-id="element-2450" data-mp="r7gu8bvmc1kz">
          
            <div className="bg-brand-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-2451" data-mp="11651cfm2ew9w">
              <CheckCircle className="w-10 h-10 text-brand-600" data-id="element-2452" data-mp="16611g3rn63k6" />
            </div>
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-2453" data-mp="8iiwl413pllg">
              Your email client should open shortly!
            </h2>
            <p className="text-slate-600 mb-8 max-w-md mx-auto" data-id="element-2454" data-mp="dhlr3ujgg9f6">
              Please send the pre-filled email to complete your message. If your
              email client didn't open, you can email us directly at{' '}
              <a href="mailto:intellieats@gmail.com" className="text-brand-600 font-medium hover:text-brand-700" data-id="element-2455" data-mp="n8zwgiy383g8">
              
                intellieats@gmail.com
              </a>
            </p>
            <button onClick={() => {
          setSubmitted(false);
          setName('');
          setEmail('');
          setMessage('');
        }} className="px-6 py-3 bg-brand-600 text-white font-semibold rounded-xl hover:bg-brand-700 transition-colors" data-id="element-2456" data-mp="3qtvu6z5c7r77">
            
              Send Another Message
            </button>
          </motion.div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-2457" data-mp="1u1melsl0o0v5">
            <div data-id="element-2458" data-mp="1u3gw0wx2xauh">
              <label htmlFor="name" className="flex items-center gap-2 text-sm font-semibold text-slate-900 mb-2" data-id="element-2459" data-mp="1p1rlrjhol17g">
              
                <User className="w-4 h-4 text-slate-500" data-id="element-2460" data-mp="1ka8f3kt2f120" />
                Your Name
              </label>
              <input type="text" id="name" value={name} onChange={e => setName(e.target.value)} required placeholder="Enter your full name" className="w-full px-4 py-3.5 bg-slate-50 border border-slate-200 rounded-xl text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition-all" data-id="element-2461" data-mp="1gahiv1krrsq3" />
            
            </div>

            <div data-id="element-2462" data-mp="31eey4o3w6wki">
              <label htmlFor="email" className="flex items-center gap-2 text-sm font-semibold text-slate-900 mb-2" data-id="element-2463" data-mp="31fzpy5yto1eo">
              
                <Mail className="w-4 h-4 text-slate-500" data-id="element-2464" data-mp="36fulwnxgfh6l" />
                Email Address
              </label>
              <input type="email" id="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="your@email.com" className="w-full px-4 py-3.5 bg-slate-50 border border-slate-200 rounded-xl text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition-all" data-id="element-2465" data-mp="2rn0zsjnog2sy" />
            
            </div>

            <div data-id="element-2466" data-mp="28ru93uaw2wk4">
              <label htmlFor="message" className="flex items-center gap-2 text-sm font-semibold text-slate-900 mb-2" data-id="element-2467" data-mp="28sdlywlomura">
              
                <MessageSquare className="w-4 h-4 text-slate-500" data-id="element-2468" data-mp="6yegwsz5l9n1" />
                Message
              </label>
              <textarea id="message" value={message} onChange={e => setMessage(e.target.value)} required rows={6} placeholder="Tell us how we can help you..." className="w-full px-4 py-3.5 bg-slate-50 border border-slate-200 rounded-xl text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition-all resize-none" data-id="element-2469" data-mp="bwo86shrbq3d" />
            
            </div>

            <button type="submit" className="w-full flex items-center justify-center gap-2 px-6 py-4 bg-brand-600 text-white font-bold rounded-xl hover:bg-brand-700 transition-all shadow-lg shadow-brand-200/50 hover:shadow-brand-300/50 hover:-translate-y-0.5 duration-200" data-id="element-2470" data-mp="21da3x3kxm4qz">
            
              <Send className="w-5 h-5" data-id="element-2471" data-mp="2p34f7gplrl94" />
              Send Message
            </button>

            <p className="text-center text-sm text-slate-500" data-id="element-2472" data-mp="2k6e0oxtg4xpt">
              Your message will be sent to{' '}
              <span className="font-medium text-slate-700" data-id="element-2473" data-mp="ur7knevv5z9u">
                intellieats@gmail.com
              </span>{' '}
              via your email client.
            </p>
          </form>}

        {/* Direct Contact Info */}
        <div className="mt-16 pt-12 border-t border-slate-100" data-id="element-2474" data-mp="2pvnqef123hv5">
          <h3 className="text-lg font-bold text-slate-900 mb-6 text-center" data-id="element-2475" data-mp="2utpa926b3l7o">
            Other Ways to Reach Us
          </h3>
          <div className="grid sm:grid-cols-2 gap-6" data-id="element-2476" data-mp="2ysy0vy61v2z0">
            <div className="bg-slate-50 rounded-2xl p-6 border border-slate-100 text-center" data-id="element-2477" data-mp="33tm1nbk2yy6f">
              <Mail className="w-6 h-6 text-brand-600 mx-auto mb-3" data-id="element-2478" data-mp="38sykzmbqtn49" />
              <h4 className="font-bold text-slate-900 mb-1" data-id="element-2479" data-mp="3drjp3wu48qxz">Email</h4>
              <a href="mailto:intellieats@gmail.com" className="text-brand-600 hover:text-brand-700 text-sm font-medium transition-colors" data-id="element-2480" data-mp="3dpp30f73yssb">
                
                intellieats@gmail.com
              </a>
            </div>
            <div className="bg-slate-50 rounded-2xl p-6 border border-slate-100 text-center" data-id="element-2481" data-mp="3riy9a6zrey6m">
              <MessageSquare className="w-6 h-6 text-brand-600 mx-auto mb-3" data-id="element-2482" data-mp="3rh3p4uwbba3l" />
              <h4 className="font-bold text-slate-900 mb-1" data-id="element-2483" data-mp="cww9sw8huic">
                App Store Review
              </h4>
              <p className="text-sm text-slate-600" data-id="element-2484" data-mp="ae7iquu1xnkm">
                Leave feedback on the App Store or Google Play
              </p>
            </div>
          </div>
        </div>
      </div>
    </motion.div>;
}